import React, { useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compareComplexProps } from 'helpers/memo';
import ControlledTabs from 'components/shared/ControlledTabs';
import Card from 'components/trade/Card';
import OrderBook from './OrderBook';
import TradeHistory from './TradeHistory';
import styles from './styles.module.scss';

function OrderBookAndHistory(props) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const OrderBookAndHistoryTabs = [{ label: t('market_order_book') }, { label: t('market_trade_history') }];

  const refetchForOrderBook = () => {
    if (props.orderBook.error) props.orderBook.refetch();
    if (props.markets.error) props.markets.refetch();
  };

  const refetchForTrades = () => {
    if (props.trades.error) props.trades.refetch();
    if (props.markets.error) props.markets.refetch();
  };

  const cardProps = {
    cardStyles: [styles.comboCard],
    contentWrapperStyles: [styles.cardContents],
    headerComponent: (
      <div className={styles.tabWrap}>
        <ControlledTabs
          tabs={OrderBookAndHistoryTabs}
          activeTabIndex={activeTab}
          setActiveTabIndex={setActiveTab}
          rowStyles={[styles.textTabRow]}
          buttonStyles={[styles.textTabButton]}
          border={false}
          trading
        />
      </div>
    )
  };

  if (activeTab === 0) {
    return (
      <Card
        {...cardProps}
        loading={props.markets.loading || props.orderBook.loading}
        error={props.markets.error || props.orderBook.error}
        errorRefetch={refetchForOrderBook}>
        <div className={styles.contentContainer}>
          <OrderBook
            orderBook={props.orderBook.data}
            market={props.markets.data.markets}
            onClickOrder={props.onClickOrder}
          />
        </div>
      </Card>
    );
  }
  return (
    <Card
      {...cardProps}
      loading={props.markets.loading || props.trades.loading}
      error={props.markets.error || props.trades.error}
      errorRefetch={refetchForTrades}>
      <div className={styles.contentContainer}>
        <TradeHistory trades={props.trades.data?.body ?? []} market={props.markets.data.markets} />
      </div>
    </Card>
  );
}

OrderBookAndHistory.propTypes = {
  pair: PropTypes.string.isRequired,
  markets: PropTypes.object.isRequired,
  orderBook: PropTypes.object.isRequired,
  trades: PropTypes.object.isRequired,
  onClickOrder: PropTypes.func.isRequired
};

export default memo(OrderBookAndHistory, compareComplexProps);
